import React from 'react';
import { Route } from 'react-router-dom';
import loadableModule from 'spark-views/main/loadableModule';
import { paths } from './gapPacketRoutes';
import GapPacketRecipientHome from './GapPacketRecipientHome';

const GapPacket = loadableModule(() => import('./index.js'));

const GapPacketRoute = () => (
	<React.Fragment>
		<Route path={paths.root} component={GapPacket} />
		<Route path={paths.acknowledge} component={GapPacketRecipientHome} />
	</React.Fragment>
);

export default GapPacketRoute;